import { LockClosed } from "assets/icons";
import React from "react";

const FormButton = ({
  type = "",
  disabled = false,
  isSubmitting = false,
  text,
  onClick,
  variant = "filled",
  isLocked = false,
  height = "h-8",
}) => {
  const buttonClass = disabled
    ? "cursor-not-allowed bg-[#d4f9f9] hover:bg-[#d4f9f9] border-transparent text-slate-400"
    : variant === "filled"
    ? "text-white bg-secondary bg-gradient-to-b from-[#1ab5c0] to-[#1996a6] hover:from-[#1996a6] hover:to-[#1a7684] border-transparent"
    : "text-black bg-white hover:bg-gray-100 border border-gray-300";

  return (
    <button
      type={type}
      disabled={disabled}
      className={`group relative w-full flex items-center justify-center py-2 ${height} text-[1em] font-medium rounded-md ${buttonClass}`}
      onClick={onClick}
    >
      {isSubmitting ? "Processing..." : text}
      {isLocked && (
        <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
          <LockClosed width={16} />
        </div>
      )}
    </button>
  );
};

export default FormButton;
